module.exports = __webpack_public_path__ + "static/media/book_line.fb60b1bb.png";